import { ENTERPRISE, STARTER, tabIdToProductLevels } from '../constants/Tabs';
export const isValidTab = tab => {
  return tab === STARTER || tab === ENTERPRISE;
};
export const getProductLevelsForTab = tab => {
  if (!tab) {
    return ['FREE', 'STARTER', 'PROFESSIONAL', 'ENTERPRISE'];
  }
  return tabIdToProductLevels[tab];
};
export const filterProductsConfigByTab = (fullConfig, tab) => {
  if (!tab) {
    return fullConfig;
  }
  const allowedLevels = getProductLevelsForTab(tab);

  // PROFESSIONAL and ENTERPRISE are always required by HubMerchCardLayoutUI
  // Only STARTER is optional
  const shouldIncludeStarter = allowedLevels.includes('STARTER');
  const filteredConfig = {
    PROFESSIONAL: fullConfig.PROFESSIONAL,
    ENTERPRISE: fullConfig.ENTERPRISE
  };

  // Add STARTER if it's allowed for this tab and exists in fullConfig
  if (shouldIncludeStarter && fullConfig.STARTER) {
    filteredConfig.STARTER = fullConfig.STARTER;
  }
  return filteredConfig;
};